import React from 'react'
import { Platform } from 'react-native'

import { useIntl } from 'react-intl'

import Text from 'app/components/base/Text'
import BidHistoryDialog from 'app/components/dialogs/BidHistoryDialog'
import useModal from 'app/hooks/useModal'
import { useGetLastBids } from 'app/services/Query/auction/auction.query'

interface BidHistoryProps {
  auctionId: number
  bidsCount: number
  currency: string
}

const BidHistory: RFC<BidHistoryProps> = ({
  auctionId,
  bidsCount,
  currency
}) => {
  const intl = useIntl()
  const { open, showModal, hideModal } = useModal()

  const { data = { bids: [] } } = useGetLastBids({
    auctionId,
    options: {
      enabled: open
    }
  })
  const { bids } = data

  const text = !!bidsCount
    ? intl.formatMessage({ defaultMessage: '{bidsCount} bids' }, { bidsCount })
    : intl.formatMessage({ defaultMessage: 'No bids' })

  return (
    <>
      <Text
        variant="subtitle2"
        component="p"
        {...(!!bidsCount && { onClick: showModal })}
        sx={{
          height: 18,
          color: 'text.third',
          ...(!!bidsCount &&
            Platform.select({
              web: {
                borderBottom: '1px solid',
                borderBottomColor: 'text.third',
                cursor: 'pointer',
                ':hover': {
                  borderBottom: 'none'
                }
              },
              native: {
                borderBottomWidth: 1,
                borderBottomColor: 'text.third',
                borderStyle: 'solid'
              }
            }))
        }}
      >
        {text}
      </Text>

      {open && !!bids?.length && (
        <BidHistoryDialog
          open={open}
          onClose={hideModal}
          bids={bids}
          currency={currency}
        />
      )}
    </>
  )
}

export default BidHistory
